export default __webpack_public_path__ + "static/media/hekma.01e3d434.png";